// src/hooks/useSampleGenotyper.ts
import { useQuery } from "@tanstack/react-query";

import { fetchSampleGenotyper } from "../../api/labiq/GenotyperApi";
import type { SampleGenotyper } from "../../types/lab/GenotyperTypes";

export const SAMPLE_GENOTYPER_QUERY_KEY = "genotyper-sample";

// Read-only results; App's 5-minute staleTime is fine, labiq invalidates its own cache when a run reloads them.
export const useSampleGenotyper = (sampleId?: string | null) =>
	useQuery<SampleGenotyper, Error>({
		queryKey: [SAMPLE_GENOTYPER_QUERY_KEY, sampleId],
		queryFn: () => fetchSampleGenotyper(sampleId as string),
		enabled: !!sampleId,
	});

export default useSampleGenotyper;
